"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var TIME_DIVISOR = exports.TIME_DIVISOR = 1000;

var RADIX = exports.RADIX = 62;

var TIMESTAMP_LENGTH = exports.TIMESTAMP_LENGTH = 6;
var CLIENT_ID_LENGTH = exports.CLIENT_ID_LENGTH = 6;
var CLIENT_TICK_LENGTH = exports.CLIENT_TICK_LENGTH = 2;
var ELEMENT_ID_LENGTH = exports.ELEMENT_ID_LENGTH = TIMESTAMP_LENGTH + CLIENT_ID_LENGTH + CLIENT_TICK_LENGTH;

var TICK_MAX = exports.TICK_MAX = RADIX * RADIX;
var CLIENT_OFFSET_MAX = exports.CLIENT_OFFSET_MAX = RADIX * RADIX * RADIX * RADIX;


//////////////////
// WEBPACK FOOTER
// ./src/common/uid/uidConstants.js
// module id = 487
// module chunks = 0